import _, {isString} from "lodash";
import {PackageConfig} from "./configurationStore.ts";


export const formatStoreData = (dataProduct: any[]) => {
    return _.mapValues(dataProduct, (value: any, key: string) => {
        if(key === "package"){
            if(!value.packages) value.packages = []
            else{
                value.packages = _.map(value.packages, (v: any) => {
                    v.prix_du_package_par_personne = parseFloat(v.prix_du_package_par_personne)
                    v.nombre_de_package_minimum = parseFloat(v.nombre_de_package_minimum)
                    v.nombre_de_package_maximum = parseFloat(v.nombre_de_package_maximum)
                    if(!v.types_de_billet) v.types_de_billet = []
                    else{
                        v.types_de_billet = _.map(v.types_de_billet, (vv: any) => {
                            vv.prix_du_type_de_billet = parseFloat(vv.prix_du_type_de_billet)
                            return vv
                        })
                    }
                    if(!v.liste_des_villes_de_depart) v.liste_des_villes_de_depart = []
                    else{
                        v.liste_des_villes_de_depart = _.map(v.liste_des_villes_de_depart, (vv: any) => {
                            vv.prix_de_la_ville_de_depart = parseFloat(vv.prix_de_la_ville_de_depart)
                            return vv
                        })
                    }
                    if(!v.categorie_de_chambre) v.categorie_de_chambre = []
                    else{
                        v.categorie_de_chambre = _.map(v.categorie_de_chambre, (vv: any) => {
                            vv.prix = parseFloat(vv.prix)
                            vv.prix_chambre_double = parseFloat(vv.prix_chambre_double || "0")
                            vv.prix_chambre_twin = parseFloat(vv.prix_chambre_twin || "0")
                            vv.prix_chambre_single = parseFloat(vv.prix_chambre_single || "0")
                            vv.stock_chambre_double = parseFloat(vv.prix_chambre_double || "0")
                            vv.stock_chambre_twin = parseFloat(vv.prix_chambre_twin || "0")
                            vv.stock_chambre_single = parseFloat(vv.prix_chambre_single || "0")
                            if(!vv.prolongation_de_sejour) vv.prolongation_de_sejour = []
                            else{
                                vv.prolongation_de_sejour = _.map(vv.prolongation_de_sejour, (vvv: any) => {
                                    vvv.prix = parseFloat(vvv.prix)
                                    return vvv
                                })
                            }
                            return vv
                        })
                    }
                    return v
                })
            }
            value.nombre_de_place_max_possible = parseInt(value.nombre_de_place_max_possible);
        }
        if(key === "gestion_du_transport"){
            if(!value.stock_par_ville_de_depart) value.stock_par_ville_de_depart = []
            else{
                value.stock_par_ville_de_depart = _.map(value.stock_par_ville_de_depart, (v: any) => {
                    v.stock = parseFloat(v.stock)
                    return v
                })
            }

        }
        if(key === "gestion_assurances"){
            value.prix_assurance_rapatriement = parseFloat(value.prix_assurance_rapatriement || "0")
            value.prix_en_pourcentage_de_panier_de_l_assurance_annulation = parseFloat(value['prix_en_%_de_panier_de_l\’assurance_annulation'] || "0")
        }
        if(key === "gestion_des_dates"){
            value.listes_des_dates = _.map(value.listes_des_dates, (v: any) => isString(v) ? v : v.date)
        }

        return value;
    }) as unknown as PackageConfig
}
